/**
 * Authentication utility functions
 */

export const auth = {
  /**
   * Check if user is authenticated
   */
  isAuthenticated() {
    return !!localStorage.getItem('user-token');
  },

  /**
   * Get the auth token
   */
  getToken() {
    return localStorage.getItem('user-token');
  },

  /**
   * Get user info
   */
  getUserInfo() {
    const userInfo = localStorage.getItem('user-info');
    return userInfo ? JSON.parse(userInfo) : null;
  },

  /**
   * Set auth token and user info
   */
  setAuth(token, userInfo) {
    localStorage.setItem('user-token', token);
    if (userInfo) {
      localStorage.setItem('user-info', JSON.stringify(userInfo));
    }
  },

  /**
   * Clear auth data (logout)
   */
  logout() {
    localStorage.removeItem('user-token');
    localStorage.removeItem('user-info');
  }
};

export default auth;
